function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LSCheckoutProcessor = {
  $payForm: null,
  initialize: function initialize(options) {
    this.$payForm = options.$payForm;
    this.submitButtons = options.submitButtons;
    LSStripe.initialize({
      $payForm: this.$payForm
    });
  },
  // ***************************************
  // PAYMENT SUBMISSION PROCESS
  // ***************************************

  onPayFormSubmit: function () {
    var _onPayFormSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var self;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            self = this;
            if (!(!clientData.queryString || !clientData.queryString.tplId || clientData.queryString.tplId !== clientData.tplId)) {
              _context.next = 10;
              break;
            }
            if (!self.validateCCForm(e)) {
              _context.next = 8;
              break;
            }
            LSCheckout.submitButtons.map(function (btn) {
              btn.start();
            });
            e.preventDefault();
            e.stopPropagation();
            _context.next = 8;
            return self.firstTimeCustomerSubmit(e);
          case 8:
            _context.next = 19;
            break;
          case 10:
            if (!($('#card-front').is(':visible') || $('#card-front-lg').is(':visible'))) {
              _context.next = 18;
              break;
            }
            LSCheckout.submitButtons.map(function (btn) {
              btn.start();
            });
            e.preventDefault();
            e.stopPropagation();
            _context.next = 16;
            return self.returningCustomerSubmit(e);
          case 16:
            _context.next = 19;
            break;
          case 18:
            if (this.validateCCForm(e)) {
              LSCheckout.submitButtons.map(function (btn) {
                btn.start();
              });
              e.preventDefault();
              e.stopPropagation();
              this.specialPaymentKeySubmit().done(function (resp) {
                if (resp) {
                  self.processPaymentSubmitResponse(resp);
                } else {
                  self.updateCustomerCard(e).done(function () {
                    self.returningCustomerSubmit(e);
                  });
                }
              });
            }
          case 19:
            return _context.abrupt("return", false);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function onPayFormSubmit(_x) {
      return _onPayFormSubmit.apply(this, arguments);
    }
    return onPayFormSubmit;
  }(),
  validateCCForm: function validateCCForm(e) {
    var res;
    if ($('.StripeElement--empty').length > 0) {
      e.preventDefault();
      $('.StripeElement--empty').addClass('StripeElement--invalid');
    }
    if (e.isDefaultPrevented() && ($('.has-error').length > 0 || $('.StripeElement--invalid').length > 0)) {
      $('[id="error-msg"]').show();
      res = false;
    } else {
      $('[id="error-msg"]').hide();
      res = true;
    }
    return res;
  },
  resetPaymentMsg: function resetPaymentMsg() {
    $('.msg-payment-status').hide();
    $('.msg-payment-status .auth').hide();
    $('.msg-payment-status .processing').show();
  },
  firstTimeCustomerSubmit: function () {
    var _firstTimeCustomerSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
      var self, results, isSet, isSpecial, _clientData$emails, $email, email, addonWithPlans, tokenizeCard, productJson, pkgJson, planJson, newClientData;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            self = this;
            setTimeout(function () {
              clearInterval(self.redirectLoop);
              self.redirectLoop = 0;
              LSCheckout.submitButtons.map(function (btn) {
                btn.stop();
              });
            }, 5 * 60 * 1000);
            self.resetPaymentMsg();
            _context3.next = 5;
            return Promise.all([this.isPayKeyAlreadySet(), this.specialPaymentKeySubmit()]);
          case 5:
            results = _context3.sent;
            isSet = results[0];
            isSpecial = results[1];
            if (!isSet) {
              _context3.next = 12;
              break;
            }
            // avoid having duplicate payments when user click multiple times on the btn
            // or previous payment went through, but timed out on page
            // or pay page opened on multiple tabs and user already paid on another tab...
            if (!window.isRedirecting) {
              window.isRedirecting = true;
              if (window.location.href.indexOf("fromNgd") >= 0) window.location.href = LSUtils.url() + '/paid?fromNgd';else window.location.href = LSUtils.url() + '/status/?clientId=' + clientData.clientId;
            }
            _context3.next = 50;
            break;
          case 12:
            if (!isSpecial) {
              _context3.next = 16;
              break;
            }
            self.processPaymentSubmitResponse(isSpecial);
            _context3.next = 50;
            break;
          case 16:
            $email = $('form .input-email');
            email = $email.val() ? $email.val() : (_clientData$emails = clientData.emails) === null || _clientData$emails === void 0 ? void 0 : _clientData$emails.contact;
            addonWithPlans = LSCart.items.find(function (e) {
              return e.type === 'plan';
            });
            tokenizeCard = function tokenizeCard() {
              LSStripe.tokenize(email).done(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(err, token) {
                  var resp;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!token) {
                          _context2.next = 14;
                          break;
                        }
                        _context2.prev = 1;
                        _context2.next = 4;
                        return LSStripe.post(token, email);
                      case 4:
                        resp = _context2.sent;
                        resp ? self.processPaymentSubmitResponse(resp) : self.processPaymentSubmitResponseError('');
                        $('.msg-payment-status').show();
                        _context2.next = 12;
                        break;
                      case 9:
                        _context2.prev = 9;
                        _context2.t0 = _context2["catch"](1);
                        self.processPaymentSubmitResponseError(_context2.t0.message);
                      case 12:
                        _context2.next = 15;
                        break;
                      case 14:
                        // card could not be tokenized
                        self.processPaymentSubmitResponseError(err);
                      case 15:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 9]]);
                }));
                return function (_x3, _x4) {
                  return _ref.apply(this, arguments);
                };
              }());
            };
            if (!(addonWithPlans && !clientData.product.isSubscription)) {
              _context3.next = 24;
              break;
            }
            // single charge + addon with plan (reg off)
            // 1st charge paid w/ main charge + subscription w/ trial (1m or 1y)
            tokenizeCard();
            _context3.next = 50;
            break;
          case 24:
            if (!clientData.product.isSubscription) {
              _context3.next = 49;
              break;
            }
            // tlp is a subscription
            productJson = clientData.product;
            pkgJson = LSCart.items[0];
            planJson = pkgJson.stripe.plans.find(function (e) {
              return e.id === LSCart.items[1].id;
            });
            productJson.option = {
              planId: planJson.priceId
            };
            _context3.prev = 29;
            $('.msg-payment-status').show();
            _context3.next = 33;
            return LSStripe.createCustomer(clientData.clientId, email);
          case 33:
            _context3.next = 35;
            return this.updateCustomerCard();
          case 35:
            _context3.next = 37;
            return LSStripe.processSubscription(clientData, productJson);
          case 37:
            _context3.next = 43;
            break;
          case 39:
            _context3.prev = 39;
            _context3.t0 = _context3["catch"](29);
            self.resetPaymentMsg();
            // may not have a clientData.orderData yet (when arriving directly on checkout)
            self.processSubscriptionPaymentResponse(clientData.orderData.subscriptions[productJson.id]);
          case 43:
            _context3.next = 45;
            return LSUtils.waitForUpdate('orderData.subscriptions["' + productJson.id + '"].charges.length > 0', LSUtils.url() + '/app/services/customers?admin-token-424242&clientId=' + clientData.clientId);
          case 45:
            newClientData = _context3.sent;
            self.processSubscriptionPaymentResponse(newClientData.orderData.subscriptions[productJson.id], productJson.id);
            _context3.next = 50;
            break;
          case 49:
            // tlp is a single charge

            tokenizeCard();
          case 50:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this, [[29, 39]]);
    }));
    function firstTimeCustomerSubmit(_x2) {
      return _firstTimeCustomerSubmit.apply(this, arguments);
    }
    return firstTimeCustomerSubmit;
  }(),
  returningCustomerSubmit: function () {
    var _returningCustomerSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var self, dfd, productJson, pkgJson, planJson, newClientData, _newClientData;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            self = this;
            dfd = $.Deferred();
            self.resetPaymentMsg();
            $('.msg-payment-status').show();
            if (!clientData.product.isSubscription) {
              _context4.next = 18;
              break;
            }
            // subscription
            productJson = clientData.product;
            pkgJson = LSCart.items[0];
            planJson = pkgJson.stripe.plans.find(function (e) {
              return e.id === LSCart.items[1].id;
            });
            productJson.option = {
              planId: planJson.priceId
            };

            // subscribe user
            _context4.next = 11;
            return LSStripe.processSubscription(clientData, productJson);
          case 11:
            _context4.next = 13;
            return LSUtils.waitForUpdate('orderData.subscriptions["' + productJson.id + '"].charges.length > 0', LSUtils.url() + '/app/services/customers?admin-token-424242&clientId=' + clientData.clientId);
          case 13:
            newClientData = _context4.sent;
            // process response (3ds, success, failure)
            self.processSubscriptionPaymentResponse(newClientData.orderData.subscriptions[productJson.id], productJson.id);
            dfd.resolve();
            _context4.next = 32;
            break;
          case 18:
            _context4.prev = 18;
            _context4.next = 21;
            return LSStripe.charge(clientData.clientId, LSCart.getOptionIds(), LSCart.getPackageId());
          case 21:
            _context4.next = 23;
            return LSUtils.waitForUpdate('orderData.status', LSUtils.url() + '/app/services/customers?admin-token-424242&clientId=' + clientData.clientId);
          case 23:
            _newClientData = _context4.sent;
            self.processPaymentSubmitResponse({
              data: _newClientData
            });
            dfd.resolve();
            _context4.next = 32;
            break;
          case 28:
            _context4.prev = 28;
            _context4.t0 = _context4["catch"](18);
            self.processPaymentSubmitResponseError(_context4.t0.message);
            dfd.resolve();
          case 32:
            return _context4.abrupt("return", dfd.promise());
          case 33:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this, [[18, 28]]);
    }));
    function returningCustomerSubmit() {
      return _returningCustomerSubmit.apply(this, arguments);
    }
    return returningCustomerSubmit;
  }(),
  updateCustomerCard: function updateCustomerCard() {
    var self = this;
    var dfd = $.Deferred();
    LSStripe.tokenize(null, true, {
      name: $('.input-name').val(),
      address_line1: $('.input-address-line-1').val(),
      address_line2: $('.input-address-line-2').val(),
      address_city: $('.input-address-city').val(),
      address_zip: $('.input-address-zip').val(),
      address_country: clientData.config.merchant.countryCode
    }).done(function (err, token) {
      if (token) {
        LSStripe.updateCard(token, clientData.clientId).done(function (resp) {
          if (resp.status === 'error') {
            self.processCardUpdateResponse(resp);
            dfd.reject();
          } else {
            self.processCardUpdateResponse(resp);
            dfd.resolve();
          }
        });
      } else {
        self.processCardUpdateResponse({
          error: err
        });
        dfd.reject();
      }
    });
    return dfd.promise();
  },
  specialPaymentKeySubmit: function specialPaymentKeySubmit() {
    var self = this;
    var dfd = $.Deferred();
    if ($('.input-name').val() === '42') {
      LSStripe.post('TEST KEY', $('.input-email').val()).done(function (resp) {
        dfd.resolve(resp);
      });
    } else if ($('.input-name').val() === '42 CASH') {
      LSStripe.post('CASH KEY', $('.input-email').val()).done(function (resp) {
        dfd.resolve(resp);
      });
    } else if ($('.input-name').val() === '42 SUMUP') {
      LSStripe.post('SUMUP KEY', $('.input-email').val()).done(function (resp) {
        dfd.resolve(resp);
      });
    } else if ($('.input-name').val() === '42 CHECK') {
      LSStripe.post('CHECK KEY', $('.input-email').val()).done(function (resp) {
        dfd.resolve(resp);
      });
    } else {
      dfd.resolve(null);
    }
    return dfd.promise();
  },
  processPaymentSubmitResponse: function processPaymentSubmitResponse(resp) {
    var _resp$data;
    this.resetPaymentMsg();
    if (!resp.status || ((_resp$data = resp.data) === null || _resp$data === void 0 || (_resp$data = _resp$data.orderData) === null || _resp$data === void 0 || (_resp$data = _resp$data.customerId) === null || _resp$data === void 0 ? void 0 : _resp$data.indexOf('cus_')) >= 0) {
      var _resp$data2, _resp$data3;
      // stripe
      if (((_resp$data2 = resp.data) === null || _resp$data2 === void 0 || (_resp$data2 = _resp$data2.orderData) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.status) === 'requires_source_action') {
        if (!this.redirectLoop) this.redirectWhenPaymentKeySet();
        $('.msg-payment-status').show();
        $('.msg-payment-status .auth').show();
        $('.msg-payment-status .processing').hide();
        this.process3dsChargeResponse(resp.data);
      } else if (resp.error || ((_resp$data3 = resp.data) === null || _resp$data3 === void 0 || (_resp$data3 = _resp$data3.orderData) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.status) === 'declined') {
        LSCheckout.submitButtons.map(function (btn) {
          btn.stop();
        });
        if (!resp.error && resp.data.orderData.error) {
          resp.error = {
            message: resp.data.orderData.error
          };
        } else {
          if (resp.error && resp.error.message.indexOf('postal code do not match')) {
            resp.error.message += '<p>Please remember to use the billing address linked to this card,<br />it might not be your current address.</p>';
          }
        }
        this.resetPaymentMsg();
        if (resp.error) BootstrapDialog.show({
          title: 'Alert',
          message: '<div class="alert alert-danger text-center"><i class="fa fa-exclamation-circle"></i> <b>Payment declined</b><br /><br /><p>' + resp.error.message + '</p></div>',
          closable: true
        });
      } else {
        $('.msg-payment-status').show();
        $('.msg-payment-status .auth').show();
        $('.msg-payment-status .processing').hide();
        if (!this.redirectLoop) this.redirectWhenPaymentKeySet();
      }
    } else {
      // braintree
      if (resp.status === 'ok') {
        $('[id="validated-msg"]').show();
        if (!window.isRedirecting) {
          window.isRedirecting = true;
          if (this.redirectLoop) clearInterval(this.redirectLoop);
          if (resp.data && resp.data.redirect) window.location.href = resp.data.redirect;else {
            if (window.location.href.indexOf("fromNgd") >= 0) window.location.href = LSUtils.url() + '/paid?fromNgd';else {
              window.location.href = LSUtils.url() + '/status/?clientId=' + clientData.clientId;
            }
          }
        }
      } else {
        LSCheckout.submitButtons.map(function (btn) {
          btn.stop();
        });
        BootstrapDialog.show({
          title: 'Alert',
          message: '<h3 class="text-center text-danger">' + lang.checkout.declined + '<br /><br /><b>' + resp.error + '</b></h3>',
          closable: true
        });
      }
    }
  },
  processPaymentSubmitResponseError: function processPaymentSubmitResponseError(err) {
    LSCheckout.submitButtons.map(function (btn) {
      btn.stop();
    });
    this.resetPaymentMsg();
  },
  processSubscriptionPaymentResponse: function processSubscriptionPaymentResponse(subscriptionData, subscriptionKey) {
    var lastCharge = subscriptionData.charges.last();
    if (lastCharge.paymentKey && lastCharge.paymentKey !== 'PENDING_3DS' && lastCharge.paymentKey !== 'FAILURE') {
      // charged
      $('.msg-payment-status').show();
      $('.msg-payment-status .auth').show();
      $('.msg-payment-status .processing').hide();
      this.redirectWhenPaymentKeySet();
    } else if (lastCharge.paymentKey === 'PENDING_3DS') {
      // 3ds
      this.process3DSSubscription(lastCharge.client_secret, subscriptionKey);
    } else {
      // declined
      LSCheckout.submitButtons.map(function (btn) {
        btn.stop();
      });
      this.resetPaymentMsg();
      if (lastCharge.errorMsg) {
        // show error
        BootstrapDialog.show({
          title: 'Alert',
          message: '' + '<div class="alert alert-danger text-center">' + '   <i class="fa fa-exclamation-circle"></i> <b>Payment declined</b>' + '   <br /><br />' + '   <p>' + lastCharge.errorMsg + '</p>' + '</div>',
          closable: true
        });
      } else {
        // generic error
        // clientData.orderData.subscriptions[productJson.id].status
        BootstrapDialog.show({
          title: 'Alert',
          message: '' + '<div class="alert alert-danger text-center">' + '   <i class="fa fa-exclamation-circle"></i> <b>Payment declined</b>' + '   <br /><br />' + '   <p>An error occured, please try again...</p>' + '</div>',
          closable: true
        });
      }
    }
  },
  processCardUpdateResponse: function processCardUpdateResponse(resp) {
    $('.btn-declined3ds').hide();
    if (resp.status == 'error') {
      this.alert(resp.error);
      LSCheckout.submitButtons.map(function (btn) {
        btn.stop();
      });
    } else {
      if (clientData.queryString.tplId) LSCheckout.loadCCData();
    }
  },
  process3dsChargeResponse: function process3dsChargeResponse(clientData) {
    var self = this;
    var $msg;
    var chargeStatus = clientData.orderData.status;
    var isDeclined = chargeStatus === 'declined';
    var isThreeDS = chargeStatus === 'requires_source_action';
    if (isDeclined) {
      $msg = $("<div><p><b>Your credit card was declined</b> for the following service" + (declined.length > 1 ? 's' : '') + ":</p></div>");
      var $ul = $('<ul style="margin-bottom: 15px;"></ul>');
      declined.forEach(function (prod) {
        $ul.append('<li><h3>- ' + prod.replace(/-/g, ' ').titleCase() + '</h3></li>');
      });
      $msg.append($ul);
      $msg.append('<p>Please <b>click "OK" to update your credit card information</b> so we can process your service' + (declined.length > 1 ? 's' : '') + ' today.</p>');
      self.alert($msg.html());
    }
    if (isThreeDS) {
      var url = typeof threeDS !== 'undefined' && threeDS.length && threeDS[0].url ? threeDS[0].url : clientData.orderData.url;
      if (url) {
        /*
        * USE-CASE:
        * - payment for new product with new card + 3ds
        */
        $msg = $('' + '<iframe src="' + url + '" style="border: none;width: 100%;height:600px;"></iframe>' + '');
        $msg.bind('load', function () {
          try {
            if ($(this)[0].contentWindow.location.href.indexOf(LSUtils.url()) >= 0) {
              self.popup.close();
            }
          } catch (ex) {
            // nothing toi do
          }
        });
        self.popup = BootstrapDialog.show({
          message: $msg
        });
      } else {
        /*
        * USE-CASE:
        * - payment for new product with previously saved or new card + 3ds
        */
        LSStripe.show3dsModal(clientData.orderData.client_secret).done(function (result) {
          LSUtils.waitForUpdate('orderData.status', LSUtils.url() + '/app/services/customers?admin-token-424242&clientId=' + clientData.clientId).done(function (newClientData) {
            console.log(newClientData.orderData.status);
            self.processPaymentSubmitResponse({
              data: newClientData
            });
          });
        });
      }
    }
  },
  process3DSSubscription: function process3DSSubscription(client_secret, subscriptionKey) {
    var self = this;
    var dfd = $.Deferred();
    LSStripe.show3dsModal(client_secret).done(function (result) {
      if (result.error) {
        LSCheckout.submitButtons.map(function (btn) {
          btn.stop();
        });
        console.log(result.error.message);
        // show error
        BootstrapDialog.show({
          title: 'Alert',
          message: '' + '<div class="alert alert-danger text-center">' + '   <i class="fa fa-exclamation-circle"></i> <b>Payment declined</b>' + '   <br /><br />' + '   <p>' + result.error.message + '</p>' + '</div>',
          closable: true
        });
        self.resetPaymentMsg();
        dfd.resolve();
      } else {
        LSUtils.waitForUpdate('orderData.subscriptions["' + subscriptionKey + '"].charges.last().paymentKey !== "PENDING_3DS"', LSUtils.url() + '/app/services/customers?admin-token-424242&clientId=' + clientData.clientId).done(function (newClientData) {
          console.log(newClientData.orderData.subscriptions[subscriptionKey].status);
          self.processSubscriptionPaymentResponse(newClientData.orderData.subscriptions[subscriptionKey], subscriptionKey);
          dfd.resolve();
        });
      }
    });
    return dfd.promise();
  },
  redirectWhenPaymentKeySet: function redirectWhenPaymentKeySet() {
    var self = this;
    this.redirectLoop = setInterval(function () {
      $.ajax({
        url: LSUtils.url() + '/app/services/customers',
        data: {
          clientId: clientData.clientId
        },
        success: function success(resp) {
          var _newClientData$orderD;
          var newClientData = JSON.parse(resp).data[0];
          if (newClientData !== null && newClientData !== void 0 && (_newClientData$orderD = newClientData.orderData) !== null && _newClientData$orderD !== void 0 && _newClientData$orderD.paymentKey && !window.isRedirecting) {
            window.isRedirecting = true;
            clearInterval(self.redirectLoop);
            if (window.location.href.indexOf("fromNgd") >= 0) window.location.href = LSUtils.url() + '/paid?fromNgd';else window.location.href = LSUtils.url() + '/status/?thx=true&clientId=' + clientData.clientId;
          }
        }
      });
    }, 1000);
  },
  isPayKeyAlreadySet: function isPayKeyAlreadySet() {
    var dfd = $.Deferred();
    $.ajax({
      url: LSUtils.url() + '/app/services/customers',
      data: {
        clientId: clientData.clientId
      },
      success: function success(resp) {
        var clientData = JSON.parse(resp).data;
        dfd.resolve(clientData && clientData.length && clientData[0].orderData && clientData[0].orderData.paymentKey && clientData[0].orderData.paymentKey !== '');
      }
    });
    return dfd.promise();
  },
  alert: function alert(msg, onOK) {
    var config = {
      closable: true,
      title: 'Alert',
      message: $('<p class="text-center">' + msg + '</p>')
    };
    var self = this;
    if (onOK) {
      config.buttons = [{
        label: 'OK',
        cssClass: 'btn-primary',
        action: function action($dialog) {
          self.popup[msg].close();
          onOK.apply(self);
        }
      }];
    }
    if (!self.popup) self.popup = [];
    self.popup[msg] = BootstrapDialog.show(config);
  }
};
export { LSCheckoutProcessor };